// extracted by mini-css-extract-plugin
export default {"searchInput":"categoriesFormItem_searchInput__o7h3w"};